(function () {
  'use strict';

  function read(root) {
    var script = root && root.querySelector('[data-product-variant-selection-state]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }

  function isHighVariant(state) {
    return !!state && Number(state.variantsCount) > Number(state.renderedVariantsCount);
  }

  function selectedOptionValueIds(root, selector) {
    var selected = Array.prototype.slice.call(root.querySelectorAll(selector + '.active'));
    selected.sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });
    return selected.map(function (button) { return button.dataset.optionValueId; }).filter(Boolean);
  }

  function applyAvailability(root, selector, state) {
    var values = new Map();
    (state && state.options || []).forEach(function (option) {
      (option.values || []).forEach(function (value) {
        values.set(String(option.position) + ':' + String(value.id), value);
      });
    });
    root.querySelectorAll(selector).forEach(function (button) {
      var value = values.get(String(button.dataset.optionPosition) + ':' + String(button.dataset.optionValueId));
      var unavailable = !value || !value.available;
      button.classList.toggle('unavailable', unavailable);
      button.dataset.optionValueAvailable = unavailable ? 'false' : 'true';
      button.removeAttribute('aria-disabled');
      var label = button.querySelector('[data-option-unavailable-label]');
      if (label) label.hidden = !unavailable;
      if (button.dataset.optionAccessibleLabel) {
        button.setAttribute('aria-label', button.dataset.optionAccessibleLabel + (unavailable && label ? label.textContent : ''));
      }
    });
  }

  function request(productUrl, optionValueIds, signal) {
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', 'product-variant-state');
    url.searchParams.set('option_values', optionValueIds.join(','));
    return fetch(url.toString(), { credentials: 'same-origin', signal: signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Variant selection failed.');
        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var script = documentFragment.querySelector('[data-product-variant-selection-state]');
        if (!script) throw new Error('Variant selection state is missing.');
        return JSON.parse(script.textContent);
      });
  }

  window.AxiomHighVariantPicker = {
    read: read,
    isHighVariant: isHighVariant,
    selectedOptionValueIds: selectedOptionValueIds,
    applyAvailability: applyAvailability,
    request: request
  };
})();
